// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icons {
  width: 11.4px;
  height: 20px;
  position: relative;
  object-fit: contain;
}

.arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 17px;
  cursor: pointer;
}

.not-selected-top-text {
  text-decoration: none;
  position: relative;
  width: 100%;
  letter-spacing: 0.46px;
  line-height: 7px;
  text-transform: capitalize;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  min-width: 60px;
}

.not-selected-top-text-container {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.not-selected-logo {
  height: 24px;
  width: 24px;
  position: relative;
  object-fit: contain;
  cursor: pointer;
}

.not-selected-logo-container {
  width: 26px;
  height: 26px;
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.not-selected-bottom-text {
  text-decoration: none;
  position: relative;
  letter-spacing: 0.46px;
  line-height: 7px;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  min-width: 60px;
}

.not-selected-bottom-text-container {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
}

.not-selected-container,
.not-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.not-selected {
  width: 46px;
  height: 54px;
  justify-content: flex-start;
  gap: 8px;
}

.not-selected-container {
  width: 62px;
  border: 1px solid #757575;
  box-sizing: border-box;
  justify-content: center;
  padding: 8px 7px;
  flex-shrink: 0;
}

.selected-top-text {
  text-decoration: none;
  position: relative;
  letter-spacing: 0.46px;
  line-height: 9px;
  text-transform: capitalize;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  min-width: 46px;
  white-space: nowrap;
}

.selected-top-text-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.selected-logo {
  height: 32px;
  width: 32px;
  position: relative;
  object-fit: contain;
}

.selected-logo-container {
  width: 34px;
  height: 34px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.selected-bottom-text {
  text-decoration: none;
  position: relative;
  letter-spacing: 0.46px;
  line-height: 9px;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  min-width: 60px;
}

.selected-bottom-text-container {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
}

.selected-container,
.selected {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.selected {
  width: 46px;
  justify-content: flex-start;
  gap: 8px;
}

.selected-container {
  width: 70px;
  border: 1px solid #000;
  box-sizing: border-box;
  justify-content: center;
  padding: 6px 11px;
  flex-shrink: 0;
  font-size: 12px;
  color: #002129;
}

.pick-status-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  width: 100%;
  background-color: #fff;
  flex-direction: row;
  justify-content: center;
  padding: 16px 0;
  box-sizing: border-box;
  gap: 24px;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  font-size: 10px;
  color: #757575;
  font-family: Inter;
}

.placeholder .not-selected-top-text,
.placeholder .not-selected-bottom-text,
.placeholder .not-selected-logo,
.placeholder .icons {
  visibility: hidden; /* Hides the content while keeping the space */
}

.icons-desktop {
  width: 20px; /* 11.4px * 1.75 */
  height: 35px; /* 20px * 1.75 */
  position: relative;
  object-fit: contain;
}

.arrow-desktop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 35px 30px; /* 20px * 1.75, 17px * 1.75 */
}

.not-selected-top-text-desktop {
  text-decoration: none;
  position: relative;
  width: 100%;
  letter-spacing: 0.805px; /* 0.46px * 1.75 */
  line-height: 12.25px; /* 7px * 1.75 */
  text-transform: capitalize;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  min-width: 105px; /* 60px * 1.75 */
}

.not-selected-top-text-container-desktop {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 7px; /* 4px * 1.75 */
}

.not-selected-logo-desktop {
  height: 42px; /* 24px * 1.75 */
  width: 42px; /* 24px * 1.75 */
  position: relative;
  object-fit: contain;
}

.not-selected-logo-container-desktop {
  width: 45.5px; /* 26px * 1.75 */
  height: 45.5px; /* 26px * 1.75 */
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.not-selected-bottom-text-desktop {
  text-decoration: none;
  position: relative;
  letter-spacing: 0.805px; /* 0.46px * 1.75 */
  line-height: 12.25px; /* 7px * 1.75 */
  font-weight: 700;
  color: inherit;
  display: inline-block;
  min-width: 105px; /* 60px * 1.75 */
}

.not-selected-bottom-text-container-desktop {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10.5px; /* 6px * 1.75 */
}

.not-selected-container-desktop,
.not-selected-desktop {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.not-selected-desktop {
  width: 80.5px; /* 46px * 1.75 */
  height: 94.5px; /* 54px * 1.75 */
  justify-content: flex-start;
  gap: 14px; /* 8px * 1.75 */
}

.not-selected-container-desktop {
  width: 108.5px; /* 62px * 1.75 */
  border: 1px solid #757575;
  box-sizing: border-box;
  justify-content: center;
  padding: 14px 12.25px; /* 8px * 1.75, 7px * 1.75 */
  flex-shrink: 0;
}

.selected-top-text-desktop {
  text-decoration: none;
  position: relative;
  letter-spacing: 0.805px; /* 0.46px * 1.75 */
  line-height: 15.75px; /* 9px * 1.75 */
  text-transform: capitalize;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  min-width: 80.5px; /* 46px * 1.75 */
  white-space: nowrap;
}

.selected-top-text-container-desktop {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.selected-logo-desktop {
  height: 56px; /* 32px * 1.75 */
  width: 56px; /* 32px * 1.75 */
  position: relative;
  object-fit: contain;
}

.selected-logo-container-desktop {
  width: 59.5px; /* 34px * 1.75 */
  height: 59.5px; /* 34px * 1.75 */
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.selected-bottom-text-desktop {
  text-decoration: none;
  position: relative;
  letter-spacing: 0.805px; /* 0.46px * 1.75 */
  line-height: 15.75px; /* 9px * 1.75 */
  font-weight: 700;
  color: inherit;
  display: inline-block;
  min-width: 105px; /* 60px * 1.75 */
}

.selected-bottom-text-container-desktop {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 5.25px; /* 3px * 1.75 */
}

.selected-container-desktop,
.selected-desktop {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.selected-desktop {
  width: 80.5px; /* 46px * 1.75 */
  justify-content: flex-start;
  gap: 14px; /* 8px * 1.75 */
}

.selected-container-desktop {
  width: 122.5px; /* 70px * 1.75 */
  border: 1px solid #000;
  box-sizing: border-box;
  justify-content: center;
  padding: 10.5px 19.25px; /* 6px * 1.75, 11px * 1.75 */
  flex-shrink: 0;
  font-size: 21px; /* 12px * 1.75 */
  color: #002129;
}

.pick-status-bar-desktop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 35px; /* 20px * 1.75 */
  width: 100%;
  background-color: #fff;
  flex-direction: row;
  justify-content: center;
  padding: 28px 0; /* 16px * 1.75 */
  box-sizing: border-box;
  gap: 42px; /* 24px * 1.75 */
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  font-size: 17.5px; /* 10px * 1.75 */
  color: #757575;
  font-family: Inter;
}

.placeholder .not-selected-top-text-desktop,
.placeholder .not-selected-bottom-text-desktop,
.placeholder .not-selected-logo-desktop,
.placeholder .icons-desktop {
  visibility: hidden; /* Hides the content while keeping the space */
}

@media screen and (max-width: 110px) {
  .pick-locked3 {
    width: calc(100% - 40px);
  }
}
@media screen and (max-width: 102px) {
  .pick-locked1,
  .pick-locked5 {
    width: calc(100% - 40px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NFLSurvivor/NFLSurvivorStyles/SurvivorWeeklyPicks.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AAEJ;;AAAE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAGJ;;AADE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAIJ;;AAFE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAKJ;;AAHE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAMJ;;AAJE;EACE,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAOJ;;AALE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAQJ;;AALE;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;AAQJ;;AANE;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,QAAA;AASJ;;AAPE;EACE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAUJ;;AARE;EACE,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAWJ;;AATE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAYJ;;AAVE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAaJ;;AAXE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAcJ;;AAZE;EACE,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAeJ;;AAbE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAgBJ;;AAdE;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;AAiBJ;;AAfE;EACE,WAAA;EACA,2BAAA;EACA,QAAA;AAkBJ;;AAhBE;EACE,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAmBJ;;AAfE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;EAGA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAGJ;;AAAE;;;;EAIA,kBAAA,EAAA,8CAAA;AAmBF;;AAhBA;EACE,WAAA,EAAA,kBAAA;EACA,YAAA,EAAA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAmBF;;AAjBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA,EAAA,6BAAA;AAoBF;;AAlBA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA,EAAA,kBAAA;EACA,oBAAA,EAAA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA,EAAA,gBAAA;AAqBF;;AAnBA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA,EAAA,eAAA;AAsBF;;AApBA;EACE,YAAA,EAAA,gBAAA;EACA,WAAA,EAAA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAuBF;;AArBA;EACE,aAAA,EAAA,gBAAA;EACA,cAAA,EAAA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAwBF;;AAtBA;EACE,qBAAA;EACA,kBAAA;EACA,uBAAA,EAAA,kBAAA;EACA,oBAAA,EAAA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA,EAAA,gBAAA;AAyBF;;AAvBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA,EAAA,eAAA;AA0BF;;AAvBA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;AA0BF;;AAxBA;EACE,aAAA,EAAA,gBAAA;EACA,cAAA,EAAA,gBAAA;EACA,2BAAA;EACA,SAAA,EAAA,eAAA;AA2BF;;AAzBA;EACE,cAAA,EAAA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA,EAAA,2BAAA;EACA,cAAA;AA4BF;;AA1BA;EACE,qBAAA;EACA,kBAAA;EACA,uBAAA,EAAA,kBAAA;EACA,oBAAA,EAAA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA,EAAA,gBAAA;EACA,mBAAA;AA6BF;;AA3BA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AA8BF;;AA5BA;EACE,YAAA,EAAA,gBAAA;EACA,WAAA,EAAA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA+BF;;AA7BA;EACE,aAAA,EAAA,gBAAA;EACA,cAAA,EAAA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAgCF;;AA9BA;EACE,qBAAA;EACA,kBAAA;EACA,uBAAA,EAAA,kBAAA;EACA,oBAAA,EAAA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA,EAAA,gBAAA;AAiCF;;AA/BA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA,EAAA,eAAA;AAkCF;;AAhCA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;AAmCF;;AAjCA;EACE,aAAA,EAAA,gBAAA;EACA,2BAAA;EACA,SAAA,EAAA,eAAA;AAoCF;;AAlCA;EACE,cAAA,EAAA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA,EAAA,4BAAA;EACA,cAAA;EACA,eAAA,EAAA,gBAAA;EACA,cAAA;AAqCF;;AAlCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA,EAAA,gBAAA;EAGA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA,EAAA,gBAAA;EACA,sBAAA;EACA,SAAA,EAAA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA,EAAA,gBAAA;EACA,cAAA;EACA,kBAAA;AAsBF;;AAnBA;;;;EAIE,kBAAA,EAAA,8CAAA;AAsCF;;AAjCE;EACE;IACE,wBAAA;EAoCJ;AACF;AAlCE;EACE;;IAEE,wBAAA;EAoCJ;AACF","sourcesContent":[".icons {\n    width: 11.4px;\n    height: 20px;\n    position: relative;\n    object-fit: contain;\n  }\n  .arrow {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 20px 17px;\n    cursor: pointer;\n  }\n  .not-selected-top-text{\n    text-decoration: none;\n    position: relative;\n    width: 100%;\n    letter-spacing: 0.46px;\n    line-height: 7px;\n    text-transform: capitalize;\n    font-weight: 700;\n    color: inherit;\n    display: inline-block;\n    min-width: 60px;\n  }\n  .not-selected-top-text-container{\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 0 4px;\n  }\n  .not-selected-logo {\n    height: 24px;\n    width: 24px;\n    position: relative;\n    object-fit: contain;\n    cursor: pointer;\n  }\n  .not-selected-logo-container {\n    width: 26px;\n    height: 26px;\n    box-sizing: border-box;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  .not-selected-bottom-text {\n    text-decoration: none;\n    position: relative;\n    letter-spacing: 0.46px;\n    line-height: 7px;\n    font-weight: 700;\n    color: inherit;\n    display: inline-block;\n    min-width: 60px;\n  }\n  .not-selected-bottom-text-container {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 0 6px;\n  }\n  \n  .not-selected-container,\n  .not-selected {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .not-selected {\n    width: 46px;\n    height: 54px;\n    justify-content: flex-start;\n    gap: 8px;\n  }\n  .not-selected-container {\n    width: 62px;\n    border: 1px solid #757575;\n    box-sizing: border-box;\n    justify-content: center;\n    padding: 8px 7px;\n    flex-shrink: 0;\n  }\n  .selected-top-text {\n    text-decoration: none;\n    position: relative;\n    letter-spacing: 0.46px;\n    line-height: 9px;\n    text-transform: capitalize;\n    font-weight: 700;\n    color: inherit;\n    display: inline-block;\n    min-width: 46px;\n    white-space: nowrap;\n  }\n  .selected-top-text-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n  .selected-logo {\n    height: 32px;\n    width: 32px;\n    position: relative;\n    object-fit: contain;\n  }\n  .selected-logo-container {\n    width: 34px;\n    height: 34px;\n    box-sizing: border-box;\n    overflow: hidden;\n    display: flex;\n    flex-shrink: 0;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  .selected-bottom-text {\n    text-decoration: none;\n    position: relative;\n    letter-spacing: 0.46px;\n    line-height: 9px;\n    font-weight: 700;\n    color: inherit;\n    display: inline-block;\n    min-width: 60px;\n  }\n  .selected-bottom-text-container{\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 0 3px;\n  }\n  .selected-container,\n  .selected {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .selected {\n    width: 46px;\n    justify-content: flex-start;\n    gap: 8px;\n  }\n  .selected-container {\n    width: 70px;\n    border: 1px solid #000;\n    box-sizing: border-box;\n    justify-content: center;\n    padding: 6px 11px;\n    flex-shrink: 0;\n    font-size: 12px;\n    color: #002129;\n  }\n  \n\n  .pick-status-bar {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 20px;\n  }\n  .pick-status-bar {\n    width: 100%;\n    background-color: #fff;\n    flex-direction: row;\n    justify-content: center;\n    padding: 16px 0;\n    box-sizing: border-box;\n    gap: 24px;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    font-size: 10px;\n    color: #757575;\n    font-family: Inter;\n  }\n\n  .placeholder .not-selected-top-text,\n.placeholder .not-selected-bottom-text,\n.placeholder .not-selected-logo,\n.placeholder .icons {\n  visibility: hidden; /* Hides the content while keeping the space */\n}\n\n.icons-desktop {\n  width: 20px; /* 11.4px * 1.75 */\n  height: 35px; /* 20px * 1.75 */\n  position: relative;\n  object-fit: contain;\n}\n.arrow-desktop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 35px 30px; /* 20px * 1.75, 17px * 1.75 */\n}\n.not-selected-top-text-desktop {\n  text-decoration: none;\n  position: relative;\n  width: 100%;\n  letter-spacing: 0.805px; /* 0.46px * 1.75 */\n  line-height: 12.25px; /* 7px * 1.75 */\n  text-transform: capitalize;\n  font-weight: 700;\n  color: inherit;\n  display: inline-block;\n  min-width: 105px; /* 60px * 1.75 */\n}\n.not-selected-top-text-container-desktop {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0 7px; /* 4px * 1.75 */\n}\n.not-selected-logo-desktop {\n  height: 42px; /* 24px * 1.75 */\n  width: 42px; /* 24px * 1.75 */\n  position: relative;\n  object-fit: contain;\n}\n.not-selected-logo-container-desktop {\n  width: 45.5px; /* 26px * 1.75 */\n  height: 45.5px; /* 26px * 1.75 */\n  box-sizing: border-box;\n  overflow: hidden;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.not-selected-bottom-text-desktop {\n  text-decoration: none;\n  position: relative;\n  letter-spacing: 0.805px; /* 0.46px * 1.75 */\n  line-height: 12.25px; /* 7px * 1.75 */\n  font-weight: 700;\n  color: inherit;\n  display: inline-block;\n  min-width: 105px; /* 60px * 1.75 */\n}\n.not-selected-bottom-text-container-desktop {\n  align-self: stretch;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10.5px; /* 6px * 1.75 */\n}\n\n.not-selected-container-desktop,\n.not-selected-desktop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.not-selected-desktop {\n  width: 80.5px; /* 46px * 1.75 */\n  height: 94.5px; /* 54px * 1.75 */\n  justify-content: flex-start;\n  gap: 14px; /* 8px * 1.75 */\n}\n.not-selected-container-desktop {\n  width: 108.5px; /* 62px * 1.75 */\n  border: 1px solid #757575;\n  box-sizing: border-box;\n  justify-content: center;\n  padding: 14px 12.25px; /* 8px * 1.75, 7px * 1.75 */\n  flex-shrink: 0;\n}\n.selected-top-text-desktop {\n  text-decoration: none;\n  position: relative;\n  letter-spacing: 0.805px; /* 0.46px * 1.75 */\n  line-height: 15.75px; /* 9px * 1.75 */\n  text-transform: capitalize;\n  font-weight: 700;\n  color: inherit;\n  display: inline-block;\n  min-width: 80.5px; /* 46px * 1.75 */\n  white-space: nowrap;\n}\n.selected-top-text-container-desktop {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.selected-logo-desktop {\n  height: 56px; /* 32px * 1.75 */\n  width: 56px; /* 32px * 1.75 */\n  position: relative;\n  object-fit: contain;\n}\n.selected-logo-container-desktop {\n  width: 59.5px; /* 34px * 1.75 */\n  height: 59.5px; /* 34px * 1.75 */\n  box-sizing: border-box;\n  overflow: hidden;\n  display: flex;\n  flex-shrink: 0;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.selected-bottom-text-desktop {\n  text-decoration: none;\n  position: relative;\n  letter-spacing: 0.805px; /* 0.46px * 1.75 */\n  line-height: 15.75px; /* 9px * 1.75 */\n  font-weight: 700;\n  color: inherit;\n  display: inline-block;\n  min-width: 105px; /* 60px * 1.75 */\n}\n.selected-bottom-text-container-desktop {\n  align-self: stretch;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5.25px; /* 3px * 1.75 */\n}\n.selected-container-desktop,\n.selected-desktop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.selected-desktop {\n  width: 80.5px; /* 46px * 1.75 */\n  justify-content: flex-start;\n  gap: 14px; /* 8px * 1.75 */\n}\n.selected-container-desktop {\n  width: 122.5px; /* 70px * 1.75 */\n  border: 1px solid #000;\n  box-sizing: border-box;\n  justify-content: center;\n  padding: 10.5px 19.25px; /* 6px * 1.75, 11px * 1.75 */\n  flex-shrink: 0;\n  font-size: 21px; /* 12px * 1.75 */\n  color: #002129;\n}\n\n.pick-status-bar-desktop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 35px; /* 20px * 1.75 */\n}\n.pick-status-bar-desktop {\n  width: 100%;\n  background-color: #fff;\n  flex-direction: row;\n  justify-content: center;\n  padding: 28px 0; /* 16px * 1.75 */\n  box-sizing: border-box;\n  gap: 42px; /* 24px * 1.75 */\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  font-size: 17.5px; /* 10px * 1.75 */\n  color: #757575;\n  font-family: Inter;\n}\n\n.placeholder .not-selected-top-text-desktop,\n.placeholder .not-selected-bottom-text-desktop,\n.placeholder .not-selected-logo-desktop,\n.placeholder .icons-desktop {\n  visibility: hidden; /* Hides the content while keeping the space */\n}\n\n\n\n  @media screen and (max-width: 110px) {\n    .pick-locked3 {\n      width: calc(100% - 40px);\n    }\n  }\n  @media screen and (max-width: 102px) {\n    .pick-locked1,\n    .pick-locked5 {\n      width: calc(100% - 40px);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
